export function eavHasValue(eav: {value: string | null | undefined}): boolean {
    return typeof eav.value === 'string' && eav.value.trim().length > 0;
}
